import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inline", "children", "title", "onDelete", "deletable", "data", "className", "contentClassName", "countable", "count"];
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import cx from 'classnames';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Content from '../Content';
import styles from './tag.module.scss';
var Tag = function Tag(props) {
  var inline = props.inline,
    children = props.children,
    title = props.title,
    onDelete = props.onDelete,
    deletable = props.deletable,
    data = props.data,
    className = props.className,
    contentClassName = props.contentClassName,
    countable = props.countable,
    count = props.count,
    rest = _objectWithoutProperties(props, _excluded);
  var deleteHandler = function deleteHandler() {
    return onDelete(data);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(className, styles.chip, !inline && 'inline-block', _defineProperty({}, styles.chipWithCount, countable))
  }, rest), /*#__PURE__*/React.createElement(Content, {
    highlight: true,
    className: cx(styles.content, contentClassName, 'display-inline'),
    title: title
  }, children), deletable && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx(styles.deleteButton, 'icon-close'),
    onClick: deleteHandler
  }), countable && !deletable && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx(styles.countButton)
  }, count));
};
Tag.propTypes = {
  inline: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  deletable: PropTypes.bool,
  onDelete: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  countable: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Tag.defaultProps = {
  inline: true,
  title: EMPTY_STRING,
  children: EMPTY_STRING,
  className: EMPTY_STRING,
  contentClassName: EMPTY_STRING,
  deletable: false,
  onDelete: _noop,
  countable: false,
  count: EMPTY_STRING
};
export default Tag;